import polyline from '@mapbox/polyline'
import maplibregl, { GeoJSONSource, Map } from 'maplibre-gl'
import moment from 'moment-timezone'
import { useEffect } from 'react'
import EndPinPng from '../../../assets/map/end_pin.png'
import StartPinPng from '../../../assets/map/start_pin.png'
import { IWaypoint } from '../../../services/rides/rides'

interface IProps {
  map?: Map
  selectedRideId: number | null
  waypoints: IWaypoint[]
  driverPolyline: string | null
}

const DriverWaypoints = ({ map, waypoints, driverPolyline, selectedRideId }: IProps) => {
  useEffect(() => {
    if (!map) return

    if (!map.getSource('ride-route-source')) {
      map.addSource('ride-route-source', {
        type: 'geojson',
        lineMetrics: true,
        data: {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: []
          }
        }
      })
    }

    if (!map.getLayer('ride-route')) {
      map.addLayer({
        id: 'ride-route',
        type: 'line',
        source: 'ride-route-source',
        layout: {
          visibility: 'visible',
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-width': 4,
          'line-gradient': [
            'interpolate',
            ['linear'],
            ['line-progress'],
            0, 'rgba(60, 126, 255, 1)',
            0.3, 'rgba(60, 126, 255, 0.8)',
            0.7, 'rgba(60, 126, 255, 0.6)',
            1, 'rgba(60, 126, 255, 0.3)'
          ]
        }
      })
    }

    return () => {
      if (map && map.getStyle()) {
        if (map.getLayer('ride-route')) {
          map.removeLayer('ride-route')
        }
        if (map.getSource('ride-route-source')) {
          map.removeSource('ride-route-source')
        }
      }
    }
  }, [map])

  useEffect(() => {
    renderRides(waypoints)
  }, [waypoints])

  useEffect(() => {
    renderPolyline(driverPolyline)
  }, [driverPolyline])

  const renderRides = (waypoints:IWaypoint[]) => {
    if (!map) return
    const oldMarkers = map.getContainer().querySelectorAll('[name="waypoint-marker"]')
    oldMarkers.forEach(marker => {
      marker.remove()
    })

    waypoints.forEach(waypoint => {
      if (waypoint.type === 'driver_location') {
        return false
      }
      const el = document.createElement('div')
      el.setAttribute('name', 'waypoint-marker')

      const iconSrc = waypoint.type === 'pickup' ? StartPinPng : EndPinPng

      el.innerHTML = `<div style="display: flex;align-items: center;justify-content: center; flex-direction: column; opacity: 70%">
                                    <div class='waypoint-marker ${waypoint.type} ${waypoint.ride_id === selectedRideId ? 'selected' : ''}'>
                                        <p class='title'><b>${waypoint.index}) ${moment(waypoint.at).format('h:mm A')}</b></p>
                                    </div>
                                <img src=${iconSrc} class='waypoint-marker-image' alt="" /></div>`

      new maplibregl.Marker({
        element: el,
        offset: [-5, -5] })
        .setLngLat([waypoint.lon, waypoint.lat])
        .addTo(map)
    })
  }
  const renderPolyline = (newPolyline: string | null) => {
    if (!map) {
      console.warn('Map not available for polyline rendering')
      return
    }

    const source = map.getSource('ride-route-source') as GeoJSONSource
    if (!source) {
      console.warn('ride-route-source not found')
      return
    }

    if (!newPolyline) {
      source.setData({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: []
        }
      })
      return
    }

    try {
      const coordinates = polyline.decode(newPolyline)
      const geoJsonCoordinates = coordinates.map(([lat, lng]) => [lng, lat])

      source.setData({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: geoJsonCoordinates
        }
      })
    } catch (error) {
      console.error('Error decoding polyline:', error)
    }
  }

  return null
}

export default DriverWaypoints
